import { can, canAll, canAny } from '../utils/permissions.util';
import useAuth from './useAuth';

export default function usePermissions() {
  const { user } = useAuth();
  const permissions = user?.permissions || [];
  const roleId = user?.role || [];
  return {
    can: (permission) => can(roleId, permissions, permission),
    canAny: (perms) => canAny(roleId, permissions, perms),
    canAll: (perms) => canAll(roleId, permissions, perms),
  };
}